// AI-assisted: Claude 2026-08-07, human-reviewed: ausstehend
// Warteschlange fürs geführte Training: Gerät belegt → überspringen,
// nach Abschluss der nächsten Übung wird die übersprungene wieder vorgeschlagen.

export interface QueueState {
  pending: string[]    // Item-Ids in Reihenfolge; [0] = aktuelle Übung
  deferred: string[]   // übersprungen, warten auf Wiedervorschlag (FIFO)
  done: string[]       // abgeschlossen, in Reihenfolge
}

export function createQueue(itemIds: string[]): QueueState {
  return { pending: [...itemIds], deferred: [], done: [] }
}

export const current = (s: QueueState): string | null => s.pending[0] ?? null

export const isFinished = (s: QueueState): boolean => s.pending.length === 0 && s.deferred.length === 0

/** Leere pending mit wartenden deferred auffüllen (z. B. letzte Übung übersprungen). */
function normalize(s: QueueState): QueueState {
  if (s.pending.length === 0 && s.deferred.length > 0) {
    return { ...s, pending: [...s.deferred], deferred: [] }
  }
  return s
}

/** Aktuelle Übung überspringen (Gerät belegt) — kommt nach der nächsten abgeschlossenen wieder. */
export function skip(s: QueueState): QueueState {
  const cur = current(s)
  if (!cur) return s
  return normalize({ ...s, pending: s.pending.slice(1), deferred: [...s.deferred, cur] })
}

/** Aktuelle Übung für heute ganz auslassen (Schmerzen) — sie kommt NICHT wieder
 *  und zählt auch nicht als geschafft. Der Unterschied zu skip(): dort ist das
 *  Gerät nur belegt, hier tut etwas weh. */
export function drop(s: QueueState): QueueState {
  const cur = current(s)
  if (!cur) return s
  return normalize({ ...s, pending: s.pending.slice(1) })
}

/** Aktuelle Übung abschließen — danach werden übersprungene (FIFO) wieder vorgeschlagen. */
export function complete(s: QueueState): QueueState {
  const cur = current(s)
  if (!cur) return s
  return {
    pending: [...s.deferred, ...s.pending.slice(1)],
    deferred: [],
    done: [...s.done, cur],
  }
}

export const progress = (s: QueueState): { done: number; total: number } => ({
  done: s.done.length,
  total: s.pending.length + s.deferred.length + s.done.length,
})
